/* eslint-disable no-plusplus */
/* eslint-disable no-bitwise */
// generate unique id start
const MakeUniqueId = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    // custom math.random
    const arrayNumbers = new Uint32Array(2);
    const mantissa = (crypto.getRandomValues(arrayNumbers)[0] * 2 ** 20)
    + (crypto.getRandomValues(arrayNumbers)[1] >>> 12);
    // get the floating result for uniqid
    const uniqueFloatNumber = mantissa * 2 ** -52;
    result += characters.charAt(Math.floor(uniqueFloatNumber * charactersLength));
  }
  return result;
};

export default MakeUniqueId;
